import React from 'react';
import { CreateCaseRequest } from '../../services/api';
import { X } from 'lucide-react';
import './CaseModals.css';

interface NewCaseModalProps {
  isOpen: boolean;
  newCaseData: CreateCaseRequest;
  setNewCaseData: (data: CreateCaseRequest) => void;
  isCreating: boolean;
  onClose: () => void;
  onCreate: () => void;
}

const NewCaseModal: React.FC<NewCaseModalProps> = ({
  isOpen,
  newCaseData,
  setNewCaseData,
  isCreating,
  onClose,
  onCreate,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-backdrop" onClick={onClose}></div>
      <div className="new-case-modal">
        <div className="modal-header">
          <h2>Create New Case</h2>
          <button onClick={onClose} className="close-modal-btn">
            <X size={24} />
          </button>
        </div>

        <div className="modal-content">
          <div className="form-group">
            <label htmlFor="projectName">Project Name *</label>
            <input
              id="projectName"
              type="text"
              value={newCaseData.projectName}
              onChange={(e) => setNewCaseData({ ...newCaseData, projectName: e.target.value })}
              placeholder="Enter project name"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="clientName">Client Name *</label>
            <input
              id="clientName"
              type="text"
              value={newCaseData.clientName}
              onChange={(e) => setNewCaseData({ ...newCaseData, clientName: e.target.value })}
              placeholder="Enter client name"
              className="form-input"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="status">Status</label>
              <select
                id="status"
                value={newCaseData.status}
                onChange={(e) => setNewCaseData({ ...newCaseData, status: e.target.value })}
                className="form-select"
              >
                <option value="Open">Open</option>
                <option value="Archived">Archived</option>
                <option value="Closed">Closed</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="phase">Phase</label>
              <input
                id="phase"
                type="text"
                value={newCaseData.phase}
                onChange={(e) => setNewCaseData({ ...newCaseData, phase: e.target.value })}
                placeholder="e.g., Initial, Discovery, Trial"
                className="form-input"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              value={newCaseData.description}
              onChange={(e) => setNewCaseData({ ...newCaseData, description: e.target.value })}
              placeholder="Enter case description"
              className="form-textarea"
              rows={4}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="cancel-btn">
            Cancel
          </button>
          <button onClick={onCreate} disabled={isCreating} className="create-btn">
            {isCreating ? 'Creating...' : 'Create Case'}
          </button>
        </div>
      </div>
    </>
  );
};

export default NewCaseModal;

